import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'Locale';
import InfoPage from 'Pages/InfoPage';
import { Button } from 'LocalGluons';
import ForceUpdate from 'Pages/ForceUpdate';

const InitialErrorMessage = ({ errorMessage, onRetryPress }) => {
    // Fallback translations
    let heading = t('ERROR.UNKNOWN');
    if (heading === 'ERROR.UNKNOWN') heading = 'Error';
    let retryTitle = t('COMMON.RETRY');
    if (retryTitle === 'COMMON.RETRY') retryTitle = 'Retry';

    if (errorMessage.errorCode === '417' || errorMessage.errorCode === 'OLD_APP_VERSION')
        return <ForceUpdate />;

    return (
        <InfoPage heading={heading} message={errorMessage.localizedMessage}>
            <Button title={retryTitle} onPress={onRetryPress} />
        </InfoPage>
    );
};

InitialErrorMessage.propTypes = {
    // why was string required?
    // errorMessage: PropTypes.string.isRequired,
    errorMessage: PropTypes.object.isRequired,
    onRetryPress: PropTypes.func.isRequired
};

export default InitialErrorMessage;
